import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { EnumUserRole } from 'lib/graphql';
import { BaseModule } from 'lib/modules';

// Lazy-loaded page components
const VendorTeamPage = lazy(
  () => import(/* webpackChunkName: "processor-team" */ 'pages/processor/team'),
);

/**
 * Team Management Module Implementation
 *
 * Gates vendor-owner self-service team management — inviting members and
 * assigning the read-only processor role. Owner-only: a plain admin (not
 * impersonating a vendor) has no active_vendor, so vendorTeamMembers would
 * throw "No vendor is associated with your account."
 */
class TeamManagementModuleClass extends BaseModule {
  id = 'TEAM_MANAGEMENT';
  name = 'Team Management';
  label = 'Team Management';
  description = 'Vendor-owner team management and read-only processor roles';
  version = '1.0.0';
  /**
   * Creates route objects for the Team Management module
   * @param ProtectedRoute
   * @param LazyWrapper
   * @param settings
   * @param ModuleProtectedRoute
   */
  createRoutes = (
    ProtectedRoute: any,
    LazyWrapper: any,
    settings?: any,
    ModuleProtectedRoute?: any,
  ): RouteObject[] => {
    const routes: RouteObject[] = [];
    const RouteProtector = ModuleProtectedRoute || ProtectedRoute;

    routes.push({
      path: '/processor/team',
      element: (
        <RouteProtector
          component={VendorTeamPage}
          moduleId="TEAM_MANAGEMENT"
          allowedUserRoles={[EnumUserRole.VendorOwner]}
        />
      ),
    });

    return routes;
  };
}

// Export singleton instance
export const TeamManagementModule = new TeamManagementModuleClass();
